import { GetCustomeFieldMeta, GetCustomeFielPayload } from 'types/store/GetCustomerField';
import { createAsyncReducer } from 'utils/Redux';

import { getCustomeFieldActions } from '../actions';

export default createAsyncReducer<GetCustomeFieldMeta, GetCustomeFielPayload>(getCustomeFieldActions);
